import htmlToDom from '../../helpers/htmlToDom';

export default (item) =>
	htmlToDom(`
		<li class="order-history__order-element">
			<p class="order-hitory__table-name">${item['identifier']}</p>
			<p class="order-hitory__table-count">${item['quantity']}</p>
		</li>
	`);
